module.exports = __webpack_public_path__ + "media/images/countryrect/mv-94bee278f96d8974125a77166aebe314.svg";